module.exports = __webpack_public_path__ + "img/cloud-moon-rain.2999e1a6.svg";